import {Component, Prop, Vue} from "vue-property-decorator";

@Component
class Progress extends Vue {

  @Prop({required:true, type: Number}) readonly progress: number;
  @Prop({required: true, type: Number}) readonly total: number;

  get progression(){
    return this.progress / this.total * 100;
  }

  get innerStyle(){
    return {
      width: `${this.progression}%`
    }
  }

  render() {
    return (
      <div class="progress">
        <div class="progress-inner" style={this.innerStyle} />
      </div>
    );
  }
}

export default Progress;

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-b3fb6ede/progress.tsx" });